import { bigStatement } from "./bigStatement";
import { columnSplit } from "./columnSplit";
import { comparison } from "./comparison";
import { densePage } from "./densePage";
import { featureTrio } from "./featureTrio";
import { fullBleedSplit } from "./fullBleedSplit";
import { heroSplit } from "./heroSplit";
import { narrativeSplit } from "./narrativeSplit";
import { numTables } from "./numTables";
import { panoramicSplit } from "./panoramicSplit";
import { standardGrid } from "./standardGrid";
import { table } from "./table";

export const layoutExamples = [
  { name: "Big Statement", jadle: bigStatement },
  { name: "Column Split", jadle: columnSplit },
  { name: "Comparison", jadle: comparison },
  { name: "Dense Page", jadle: densePage },
  { name: "Feature Trio", jadle: featureTrio },
  { name: "Full Bleed Split", jadle: fullBleedSplit },
  { name: "Hero Split", jadle: heroSplit },
  { name: "Narrative Split", jadle: narrativeSplit },
  { name: "Number Tables", jadle: numTables },
  { name: "Panoramic Split", jadle: panoramicSplit },
  { name: "Standard Grid", jadle: standardGrid },
  { name: "Table", jadle: table },
];
